export interface CCManageOptions {
  includeSections: {
    cutoff?: boolean;
    years?: boolean;
    mentors?: boolean;
    mentees?: boolean;
    goals?: boolean;
    questions?: boolean;
    reminders?: boolean;
  };
  verbage: {
    mentor?: string;
    mentee?: string;
  };
  sortBy: "lastName" | "mentor" | "division";
}

export const _defaultManageOptions: CCManageOptions = {
  includeSections: {
    cutoff: true,
    years: true,
    mentors: true,
    mentees: true,
    goals: false,
    questions: false,
    reminders: false
  },
  verbage: {
    mentor: "Mentor",
    mentee: "Mentee"
  },
  sortBy: "lastName"
};
